// useModal hook

import { useContext } from 'preact/hooks';
import ModalContext from '../context/ModalContext.js';

const useModal = () => useContext(ModalContext);

export default useModal;
